// DİKKAT: import React from "react" KULLANMIYORUZ!
const { useState, useMemo, useCallback, useEffect } =
  window.EcommerceCore.vendors.React;
const { useAppSelector } = window.EcommerceCore.common.hooks;

const getValidTerms = (
  targetTaxonomy: string,
  currentSelections: Record<string, string>,
  product: any,
  mappings: any[],
) => {
  const validMappings = mappings.filter((mapping) => {
    return mapping.attributes.every((attr: any) => {
      if (attr.taxonomy === targetTaxonomy) return true;
      if (!currentSelections[attr.taxonomy]) return true;
      if (!attr.value) return true;
      return attr.value === currentSelections[attr.taxonomy];
    });
  });

  const validValues = new Set<string>();

  validMappings.forEach((mapping) => {
    const targetAttr = mapping.attributes.find(
      (a: any) => a.taxonomy === targetTaxonomy,
    );
    if (targetAttr && targetAttr.value) {
      validValues.add(targetAttr.value);
    } else {
      const originalAttr = product.enrichedAttributes.find(
        (a: any) => a.taxonomy === targetTaxonomy,
      );
      if (originalAttr) {
        originalAttr.terms.forEach((t: any) => validValues.add(t.slug));
      }
    }
  });

  return Array.from(validValues);
};

export const useCascadingVariations = (product: any) => {
  // Aktif para birimini Redux üzerinden dinle
  const currentCurrency = useAppSelector(
    (state: any) => state.currency.currentCurrency,
  );

  const [selectedAttributes, setSelectedAttributes] = useState<
    Record<string, string>
  >({});

  const { useGetProductVariationsQuery } = window.EcommerceCore.product.api;
  const {
    data: variations,
    isLoading,
    isFetching,
    refetch, // Yeniden yükleme fonksiyonunu dışarı alıyoruz
  } = useGetProductVariationsQuery(product?.id, {
    skip: !product?.id || !product.isVariable,
  });

  // Para birimi değiştiğinde varyasyonları yeniden yükle
  useEffect(() => {
    if (product?.id && product.isVariable) {
      refetch();
    }
  }, [currentCurrency, refetch, product?.id, product?.isVariable]);

  // EKSİK OLAN SATIR EKLENDİ
  const mappings = product?.variationAttributeMappings || [];

  const handleAttributeSelect = useCallback(
    (taxonomy: string, value: string) => {
      setSelectedAttributes((prev: Record<string, string>) => {
        let next = { ...prev, [taxonomy]: value };

        let changed = true;
        let loopCount = 0;

        while (changed && loopCount < 10) {
          changed = false;
          loopCount++;

          Object.keys(next).forEach((tax) => {
            if (next[tax]) {
              const validTerms = getValidTerms(tax, next, product, mappings);
              if (!validTerms.includes(next[tax])) {
                delete next[tax];
                changed = true;
              }
            }
          });

          product?.enrichedAttributes?.forEach((attr: any) => {
            if (attr.hasVariations && !next[attr.taxonomy]) {
              const validTerms = getValidTerms(
                attr.taxonomy,
                next,
                product,
                mappings,
              );
              if (validTerms.length === 1) {
                next[attr.taxonomy] = validTerms[0];
                changed = true;
              }
            }
          });
        }
        return next;
      });
    },
    [product, mappings],
  );

  const handleClear = useCallback(() => setSelectedAttributes({}), []);

  const availableTermsPerAttribute = useMemo(() => {
    const result: Record<string, string[]> = {};
    product?.enrichedAttributes?.forEach((attr: any) => {
      if (attr.hasVariations) {
        result[attr.taxonomy] = getValidTerms(
          attr.taxonomy,
          selectedAttributes,
          product,
          mappings,
        );
      }
    });
    return result;
  }, [product, selectedAttributes, mappings]);

  const selectedVariation = useMemo(() => {
    if (!product?.isVariable || !variations) return null;

    const requiredCount = product.enrichedAttributes.filter(
      (a: any) => a.hasVariations,
    ).length;
    const selectedCount = Object.keys(selectedAttributes).length;
    if (selectedCount < requiredCount) return null;

    return (
      variations.find((variation: any) => {
        const mapping = mappings.find((m: any) => m.id === variation.id);
        if (!mapping) return false;
        return (
          mapping.attributes.length === selectedCount &&
          mapping.attributes.every(
            (attr: any) => selectedAttributes[attr.taxonomy] === attr.value,
          )
        );
      }) || null
    );
  }, [product, variations, selectedAttributes, mappings]);

  return {
    selectedAttributes,
    selectedVariation,
    availableTermsPerAttribute,
    handleAttributeSelect,
    handleClear,
    isLoading: isLoading || isFetching,
  };
};
